import { useEffect } from 'react';
import { useAppRouter } from '../../useAppRouter';
import { getPublicRuntimeConfig } from '../../../libs/init/getPublicRuntimeConfig';
import { useExtensionsTrackingEvents } from './useExtensionsTrackingEvents';

const { paths } = getPublicRuntimeConfig();

export const useExtensionsTrackingPageVisited = (): void => {
  const router = useAppRouter();
  const { trackAppsPageVisited, trackPrototypesPageVisited } =
    useExtensionsTrackingEvents();

  useEffect(() => {
    const handleRouteChange = (): void => {
      if (router.pathname === paths.appLibrary) {
        trackAppsPageVisited();
      }
      if (router.pathname === paths.appPrototypes) {
        trackPrototypesPageVisited();
      }
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router, trackAppsPageVisited, trackPrototypesPageVisited]);
};
